// Scroll constants
export const DEFAULT_SCROLL_AMOUNT = 4;

// Pinned and index constants
export const DEFAULT_PINNED_INDEX = 1;
export const DEFAULT_INDEX = 0;
export const DEFAULT_Z_INDEX = 0;

// First index constant
export const FIRST_INDEX = 0;

// Scroll position calculation
export const SCROLL_X_POSTITION_DIVIDER = 2;

// Array manipulation
export const SPLICE_INDEX = 1;

// Index not found value
export const NO_INDEX_VALUE = -1;

